const React = require('react');

const IconWrapper = require('../IconWrapper');

const OfficialStore = ({ className, isRebrand } = {}) => (
  <IconWrapper>
    <svg
      className={className || 'with-custom-color'}
      width="24"
      height="24"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="110"
        height="110"
        transform="translate(-34.75 -35)"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1725 20.1633C11.0776 19.474 10.3501 18.2546 10.3501 16.8653V14.4868L13.7563 10.1001H26.7441L30.1503 14.4868V16.8595C30.1503 18.2497 29.4228 19.47 28.3278 20.1606V29.9003H22.022V24.5095H18.4784V29.9003H12.1725V20.1633ZM25.8628 11.9001H14.6375L12.1501 15.1036V16.8653C12.1501 18.0219 13.0877 18.9595 14.2442 18.9595C15.4008 18.9595 16.3384 18.0219 16.3384 16.8653V16.4142L16.3386 16.4024H18.1386V16.8595C18.1386 18.0181 19.0806 18.9595 20.2415 18.9595C21.4025 18.9595 22.3444 18.0181 22.3444 16.8595V16.4024H24.1444V16.4142H24.1501V16.8595C24.1501 18.0192 25.0903 18.9595 26.2502 18.9595C27.41 18.9595 28.3503 18.0192 28.3503 16.8595V15.1036L25.8628 11.9001ZM14.2442 20.7595C15.4492 20.7595 16.5263 20.2122 17.2406 19.3526C17.957 20.2124 19.0362 20.7595 20.2415 20.7595C21.4493 20.7595 22.5303 20.2102 23.2467 19.3475C23.9621 20.2101 25.042 20.7595 26.2502 20.7595C26.3435 20.7595 26.4361 20.7562 26.5278 20.7497V28.1003H23.822V22.7095L16.6784 22.7095V28.1003H13.9725V20.7501C14.0623 20.7563 14.1529 20.7595 14.2442 20.7595Z"
        fill="black"
        fill-opacity="0.9"
      />
    </svg>
  </IconWrapper>
);

module.exports = React.memo(OfficialStore);
